import { type SocialPlatform } from "../constants/socialPlatforms"
import { type MenuItem } from "./menuItem"

export type SocialLinkItem = {
    platform: SocialPlatform
    href: string
    /** Optional override set by the editor. Generated from the platform when empty. */
    label?: string
    key: string
}

/**
 * Navigation content, already resolved server-side.
 *
 * Hrefs are resolved during the fetch rather than in the components: resolving
 * story links requires the full Storyblok link table, which is far too large to
 * serialize into the page props.
 *
 * Empty arrays are meaningful: they mean "nothing usable from Storyblok", and
 * consumers fall back to the hardcoded menus.
 */
export type NavigationContent = {
    headerMenu: MenuItem[]
    footerLeftMenu: MenuItem[]
    footerCenterMenu: MenuItem[]
    socialLinks: SocialLinkItem[]
}

export const EMPTY_NAVIGATION_CONTENT: NavigationContent = {
    headerMenu: [],
    footerLeftMenu: [],
    footerCenterMenu: [],
    socialLinks: [],
}
